import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import hd from "../../assets/images/Today’s Specials.png";
import food from "../../assets/images/burgerImg.png";
import bottomImg from "../../assets/images/vector-calendar.png";
import topImg from "../../assets/images/vector-top-calendar.png";
import { addCart } from "../../helper/backend-methods";
import { customToast } from "../../components/customToast";
import { GlobalContext } from "../../context";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../context/cartProvider";

const MenuModal = ({ open, toggle, items, date, isToday }) => {
  const history = useNavigate();
  const { openCart } = useCart();
  const { updateCartCount, updateCartDrawer } = useContext(GlobalContext);
  const [productSelections, setProductSelections] = useState({});

  const getSelectedItemPrice = (item, selectedAddons = []) => {
    let totalPrice = item.price || 0;
    if (selectedAddons.length > 0) {
      selectedAddons.forEach((addon) => {
        totalPrice += parseFloat(addon.PriceAdjustment || 0);
      });
    }
    return totalPrice;
  };

  const getItemCustomizationAndAddOns = (item) => {
    if (!item || !item.productAttributes || !Array.isArray(item.productAttributes)) {
      return { customizations: [], addOns: [] };
    }
    const customizations = item.productAttributes.filter((attr) => attr.IsRequired == true);
    const addOns = item.productAttributes.filter((attr) => attr.IsRequired == false);
    return { customizations, addOns };
  };

  const handleCustomizationChange = (item, attribute, value, isRequired) => {
    const itemId = item.id || item.ProductId;
    const currentSelections = productSelections[itemId] || { selectedAddons: [], totalPrice: item.price };

    let updatedAddons;

    if (isRequired) {
      updatedAddons = currentSelections.selectedAddons.filter((a) => a.ProductAttributeMappingId !== value.ProductAttributeMappingId);
      value.isCustomize = true;
      if (value.PriceAdjustment === undefined && value.Cost !== undefined) {
        value.PriceAdjustment = value.Cost;
      }
      updatedAddons.push(value);
    } else {
      const isAlreadySelected = currentSelections.selectedAddons.some((a) => a.Id === value.Id);
      if (isAlreadySelected) {
        updatedAddons = currentSelections.selectedAddons.filter((a) => a.Id !== value.Id);
      } else {
        value.isCustomize = false;
        if (value.PriceAdjustment === undefined && value.Cost !== undefined) {
          value.PriceAdjustment = value.Cost;
        }
        updatedAddons = [...currentSelections.selectedAddons, value];
      }
    }

    const newTotalPrice = getSelectedItemPrice(item, updatedAddons);

    setProductSelections({
      ...productSelections,
      [itemId]: {
        selectedAddons: updatedAddons,
        totalPrice: newTotalPrice,
      },
    });
  };

  const isAddToCartEnabled = (item) => {
    const itemId = item.id || item.ProductId;
    const selections = productSelections[itemId];

    if (!selections) {
      const { customizations } = getItemCustomizationAndAddOns(item);
      return customizations.length === 0;
    }

    const { customizations } = getItemCustomizationAndAddOns(item);
    const requiredCount = customizations.length;
    const selectedRequiredCount = selections.selectedAddons.filter((a) => a.isCustomize).length;

    return requiredCount === selectedRequiredCount;
  };

  const createAttributeXml = (selectedAddons) => {
    if (selectedAddons && selectedAddons.length > 0) {
      let xml = "<Attributes>";
      selectedAddons.forEach((addon) => {
        xml += `<ProductAttribute ID='${addon.ProductAttributeMappingId}'>`;
        xml += "<ProductAttributeValue>";
        xml += `<Value>${addon.Id}</Value>`;
        xml += "</ProductAttributeValue>";
        xml += "</ProductAttribute>";
      });
      xml += "</Attributes>";
      return xml;
    }
    return null;
  };

  const handleModalAddToCart = (item) => {
    try {
      const itemId = item.id || item.ProductId;
      const selections = productSelections[itemId];

      if (item) {
        addCart({
          Products: [
            {
              ProductId: item.Id || item.ProductId || item.id,
              Quantity: 1,
              AttributesXml: selections ? createAttributeXml(selections.selectedAddons) : null,
            },
          ],
        }).then(({ data }) => {
          if (data.Status) {
            customToast.success("Added to Cart", "Your selected item has been successfully added.");
            updateCartCount({
              CartItemCount: data.Data.CartItemCount,
              TotalAmount: data.Data.TotalAmount,
            });
            updateCartDrawer();

            const newSelections = { ...productSelections };
            delete newSelections[itemId];
            setProductSelections(newSelections);
          }
        });
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  const getItemPrice = (item) => {
    const itemId = item.id || item.ProductId;
    const selections = productSelections[itemId];
    return selections ? selections.totalPrice : item.price;
  };

  const isOptionSelected = (item, value) => {
    const itemId = item.id || item.ProductId;
    const selections = productSelections[itemId];
    if (!selections) return false;
    return selections.selectedAddons.some((a) => a.Id === value.Id);
  };

  return (
    <Modal isOpen={open} toggle={toggle} size="lg" className="calendar-modal" centered>
      <img src={bottomImg} className="calendar-bottom" />
      <img src={topImg} className="calendar-top" />
      <ModalHeader toggle={toggle}>
        <img src={hd} alt="today-special" className="special-heading" />
        <small className="today-date">
          {date.toLocaleDateString("en-US", {
            weekday: "long",
            month: "long",
            day: "numeric",
          })}
        </small>
      </ModalHeader>

      <ModalBody>
        {items.map((item, i) => (
          <div key={i} className="modal-item">
            <div className="modal-item-header">
              <img src={item.itemImage} alt="" />
              <div>
                <h5 className="item-hd">{item.name}</h5>
                <p className="item-dis">{item.desc}</p>
              </div>
              <div className="item-cart">
                <span className="price">${getItemPrice(item).toFixed(2)}</span>
                {isToday && (
                  <button
                    className="item-btn"
                    onClick={() => handleModalAddToCart(item)}
                    disabled={!isAddToCartEnabled(item)}
                    style={{
                      opacity: isAddToCartEnabled(item) ? 1 : 0.5,
                      cursor: isAddToCartEnabled(item) ? "pointer" : "not-allowed",
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="rgba(255,255,255,1)">
                      <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z"></path>
                    </svg>{" "}
                    ADD TO CART
                  </button>
                )}
              </div>
            </div>

            {item.productAttributes?.length > 0 && (
              <div className="addons">
                {item.productAttributes
                  .slice()
                  .sort((a, b) => (b.IsRequired ? 1 : 0) - (a.IsRequired ? 1 : 0))
                  .map((attribute, attrIdx) => (
                    <div key={attrIdx} className="addOns-container">
                      <h6 className="addOns-hd">
                        {attribute.AttributeName}
                        {attribute.IsRequired && <span style={{ color: "red" }}> *</span>}:
                      </h6>

                      {attribute.productAttributeValues?.map((value, valIdx) => (
                        <div key={valIdx} className="addon-row">
                          <div className="addOn-price">
                            <span className="addon-name">{value.Name}</span>
                            { isToday ? attribute.IsRequired ? (
                              <span className="price-items">${value.Cost}</span>
                            ) : (
                              <span className="price-items">+ ${value.Cost}</span>
                            ): <></>}
                          </div>
                          <span className="addon-dots"></span>
                          {!isToday ? attribute.IsRequired ? (
                            <span className="price-items">${value.Cost}</span>
                          ) : (
                            <span className="price-items">+ ${value.Cost}</span>
                          ) : <></>}
                          {isToday && (
                            <span className="addon-action">
                              {attribute.IsRequired ? (
                                <label
                                  className="option-item"
                                  style={{
                                    border: "none",
                                    padding: 0,
                                    margin: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name={`${item.id || item.ProductId}-${attribute.AttributeName}`}
                                    value={value.Id}
                                    checked={isOptionSelected(item, value)}
                                    onChange={() => handleCustomizationChange(item, attribute, value, true)}
                                  />
                                  <span className="custom-radio"></span>
                                </label>
                              ) : (
                                <>
                                  {!isOptionSelected(item, value) ? (
                                    <button
                                      type="button"
                                      className="addon-add"
                                      onClick={() => handleCustomizationChange(item, attribute, value, false)}
                                    >
                                      + Add
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="addon-add added"
                                      onClick={() => handleCustomizationChange(item, attribute, value, false)}
                                    >
                                      Remove
                                    </button>
                                  )}
                                </>
                              )}
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}

                {isToday && !isAddToCartEnabled(item) && getItemCustomizationAndAddOns(item).customizations.length > 0 && (
                  <div style={{ color: "red", fontSize: "12px", marginTop: "8px" }}>Please select all required (*) customizations</div>
                )}
              </div>
            )}
          </div>
        ))}
      </ModalBody>

      <ModalFooter className="modal-footer-custom">
        <Button outline className="explore-btn" onClick={() => history("/menu")}>
          EXPLORE MENU
        </Button>
        {isToday && (
          <Button
            className="explore-btn view-btn"
            onClick={() => {
              openCart();
              toggle();
            }}
          >
            VIEW CART
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default MenuModal;
